<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.PEC Mail Server Setting')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row>
        <v-col md="6" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC Username')"
              name="PEC_Username"
              v-model="form.PEC_Username"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_Username.$touch()"
              prepend-inner-icon="fas fa-user"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_Username')"               
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="6" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC Password')"
              name="PEC_Password"
              v-model="form.PEC_Password"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_Password.$touch()"
              prepend-inner-icon="fas fa-key"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_Password')"               
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC SMTP Host')"
              name="PEC_SMTP_Host"
              v-model="form.PEC_SMTP_Host"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_SMTP_Host.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_SMTP_Host')"               
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC SMTP Port')"
              name="PEC_SMTP_Port"
              v-model="form.PEC_SMTP_Port"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_SMTP_Port.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              type="number"
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_SMTP_Port')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC_IMAP Host')"
              name="PEC_IMAP Host"
              v-model="form.PEC_IMAP_Host"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_IMAP_Host.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_IMAP_Host')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC_IMAP Port')"
              name="PEC_IMAP_Port"
              v-model="form.PEC_IMAP_Port"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_IMAP_Port.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              type="number"
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_IMAP_Port')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC IMAP Path')"
              name="PEC_IMAP_Path"
              v-model="form.PEC_IMAP_Path"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_IMAP_Path.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_IMAP_Path')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
              color="primary"
              :label="$t(page+'.PEC IMAP Dir')"
              name="PEC_IMAP_Dir"
              v-model="form.PEC_IMAP_Dir"
              :error-messages="fieldErrors('form.company')"
              @blur="$v.form.PEC_IMAP_Dir.$touch()"
              required
              background-color="#ff000010"
              filled
              outlined
              dense
              clearable
              clear-icon="far fa-trash-alt" 
              @click:clear="$parent.save(null,'PEC_IMAP_Dir')"                            
              @input.native="$parent.save"
          ></v-text-field>
        </v-col>
    </v-row>
    </v-container>
</v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  props: ['form'],  
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      //form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
    save: _.debounce(function (event) {
        this.$parent.updateDB(event.target.name,event.target.value)
    }, 1000),
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>